export const clasificacion = (prevClassification) => {
    const clasificaciones = {
        'Plus': 'Luxury',
        'Pro': 'Premium',
        'Start': 'Select'
    }
    return clasificaciones[prevClassification] || 'Other'
}



// WEBPACK FOOTER //
// ./src/helpers/centerClassification.js